var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyProspectNewSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_781_9809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3286 19.3857C15.7784 19.3857 19.3857 15.7784 19.3857 11.3286C19.3857 6.87873 15.7784 3.27142 11.3286 3.27142C6.87873 3.27142 3.27142 6.87873 3.27142 11.3286C3.27142 15.7784 6.87873 19.3857 11.3286 19.3857Z",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0223 17.0223L20.7286 20.7286",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30023 10.4538C7.30023 9.79787 7.83199 9.26611 8.48795 9.26611H14.1692C14.8252 9.26611 15.3569 9.79787 15.3569 10.4538V13.8332C15.3569 14.4891 14.8252 15.0209 14.1692 15.0209H8.48795C7.83199 15.0209 7.30023 14.4891 7.30023 13.8332V10.4538Z",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60211 8.99209V8.30715C9.60211 7.56552 10.2033 6.96429 10.945 6.96429H11.7121C12.4537 6.96429 13.055 7.56552 13.055 8.30715V8.99209",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_781_9809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProspectNewSelected);
export default __webpack_public_path__ + "static/media/MyProspectNewSelected.37b7469b42afedc3a0cbebd6e4624f43.svg";
export { ForwardRef as ReactComponent };